<script>
export default {
  name: "ShowActionMenuMixin",
  data: () => ({
    selectedItem: null,
    showMenu: false,
    x: 0,
    y: 0
  }),
  methods: {
    show(e, item=null) {
      this.selectedItem = item
      e.preventDefault()
      this.showMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    unSelectItem() {
      this.selectedItem = null
    },
  }
}
</script>

<style scoped>

</style>